<template>

    <Link :href="href"
        :class="{
            'font-sans': is_font_sans,
            'font-nexa': ! is_font_sans,
        }"
        class="hover:underline text-blue hover:text-opacity-90">

        <slot></slot>

    </Link>

</template>

<script>

import { defineComponent } from 'vue'
import { Link } from '@inertiajs/inertia-vue3';

export default defineComponent({

    components: {
        Link,
    },

    props: {
        href: String,
        active: String,
        is_font_sans: {
            type: Boolean,
            default: false
        }
    },

});

</script>
